<template>
  <div class="content">
    <div class="container">
      <div class="cube">
        <img src="@/assets/illustration-box-desktop.svg" alt="" />
      </div>
      <div class="figure">
        <div class="woman">
          <img src="@/assets/illustration-woman-online-desktop.svg" alt="" />
        </div>
        <div class="woman-mobile">
          <img src="@/assets/illustration-woman-online-mobile.svg" alt="" />
        </div>
      </div>
      <div class="text">
        <h1>FAQ</h1>
        <div class="question" v-bind:class="{ red: !q1 }" @click="toggle1">
          <p class="question-line" v-bind:class="{ active: q1 }">
            How many team members can I invite?
            <img
              class="arrow"
              v-bind:class="{ rotate: q1 }"
              src="@/assets/icon-arrow-down.svg"
              alt=""
            />
          </p>
          <p class="anwser" v-if="q1">
            You can invite up to 2 additional users on the Free plan. There is
            no limit on team members for the Premium plan.
          </p>
          <div class="divider"></div>
        </div>
        <div class="question" v-bind:class="{ red: !q2 }" @click="toggle2">
          <p class="question-line" v-bind:class="{ active: q2 }">
            What is the maximum file upload size?<img
              class="arrow"
              v-bind:class="{ rotate: q2 }"
              src="@/assets/icon-arrow-down.svg"
              alt=""
            />
          </p>
          <p class="anwser" v-if="q2">
            No more than 2GB. All files in your account must fit your allotted
            storage space.
          </p>
          <div class="divider"></div>
        </div>
        <div class="question" v-bind:class="{ red: !q3 }" @click="toggle3">
          <p class="question-line" v-bind:class="{ active: q3 }">
            How do I reset my password?<img
              class="arrow"
              v-bind:class="{ rotate: q3 }"
              src="@/assets/icon-arrow-down.svg"
              alt=""
            />
          </p>
          <p class="anwser" v-if="q3">
            Click “Forgot password” from the login page or “Change password”
            from your profile page. A reset link will be emailed to you.
          </p>
          <div class="divider"></div>
        </div>
        <div class="question" v-bind:class="{ red: !q4 }" @click="toggle4">
          <p class="question-line" v-bind:class="{ active: q4 }">
            Can I cancel my subscription?<img
              class="arrow"
              v-bind:class="{ rotate: q4 }"
              src="@/assets/icon-arrow-down.svg"
              alt=""
            />
          </p>
          <p class="anwser" v-if="q4">
            Yes! Send us a message and we’ll process your request no questions
            asked.
          </p>
          <div class="divider"></div>
        </div>
        <div class="question" v-bind:class="{ red: !q5 }" @click="toggle5">
          <p class="question-line" v-bind:class="{ active: q4 }">
            Do you provide additional support?<img
              class="arrow"
              v-bind:class="{ rotate: q5 }"
              src="@/assets/icon-arrow-down.svg"
              alt=""
            />
          </p>
          <p class="anwser" v-if="q5">
            Chat and email support is available 24/7. Phone lines are open
            during normal business hours.
          </p>
          <div class="divider"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Accordion",
  data() {
    return {
      q1: false,
      q2: false,
      q3: false,
      q4: false,
      q5: false,
    };
  },
  methods: {
    toggle1: function() {
      this.q1 = !this.q1;
    },
    toggle2: function() {
      this.q2 = !this.q2;
    },
    toggle3: function() {
      this.q3 = !this.q3;
    },
    toggle4: function() {
      this.q4 = !this.q4;
    },
    toggle5: function() {
      this.q5 = !this.q5;
    },
  },
};
</script>
<style lang="sass" scoped>
@import "@/styles/_variables.sass"
.content
  display: flex
  justify-content: center
  align-items: center
  height: 100%
  width: 100%
  background-image: linear-gradient($bg-gradient-1, $bg-gradient-2)
.container
  width: 1100px
  height: 570px
  background-color: white
  border-radius: 20px
  display: flex
  box-shadow: 10px 10px 10px 1px rgba(0,0 ,0 , 0.1)
  position: relative
.cube
  position: absolute
  right: 1070px
  top:200px
  z-index: 10
  width: 90px
.figure
  width: 50%
  background-image: url('../assets/bg-pattern-desktop.svg')
  // background-position: 125% 70%
  background-position: right 100px top -250px
  background-repeat: no-repeat
  position: relative
  overflow: hidden
  .woman
    position: absolute
    right: 100px
    top:60px

  .woman-mobile
    display: none
.text
  width: 50%
  padding-top: 60px
  h1
    margin-top: 0px
    margin-bottom: 40px
.divider
 border-bottom: 1px solid $divider
.red:hover > .question-line
  color: $text-red
.question
  margin-top: 20px
  padding-right: 130px
  font-size: 12px
  .question-line
    margin-bottom: 15px
    color: $text-blue
    position: relative
    margin-top: 15px
    .arrow
      position: absolute
      right:0
  .active
    color: black
    font-weight: 700
  .anwser
    color: $grayish-blue-2
    margin-bottom: 10px
    line-height: 1.1rem
  .rotate
    transform: rotate(180deg)

@media (max-width: 1100px)
  .question
    padding-right: 70px
  .text
    padding-top: 40px
@media (max-width: 830px)
  .content
    height: auto
    align-items: flex-start
  .container
    flex-direction: column
    max-width: calc( 100% - 40px )
    height: auto
    margin-top: 150px
    margin-bottom: 150px
    .text
      width: 100%
      padding-bottom: 60px
      h1
        text-align: center
      .question
        padding-right: 20px
        padding-left: 20px
  .figure
    height: 100px
    width: 100%
    background-image: url('../assets/bg-pattern-mobile.svg')
    // background-position: 125% 70%
    background-position: right 50% top -10px
    background-repeat: no-repeat
    position: relative
    overflow: visible
    .woman
      display: none
    .woman-mobile
      display: block
      position: absolute
      top: -10%
      left: 47%
      transform: translate(-50%, -50%)
</style>
